import { defaultAuthenticationType } from '../components/authentication-type';
import type { ConnectedAppFormSchema } from '../schemas';

export const defaultValues: Readonly<ConnectedAppFormSchema> = {
  id: -1,
  service_name: '',
  description: '',
  brand: null,
  legal_entity: null,
  created_at: '',
  updated_at: '',
  api_keys: [],
  authentication_type: defaultAuthenticationType,
  client_id: '',
  client_secret: '',
  authorization_url: '',
  auth_connected: false,
};
